import { mapState } from 'vuex';
import f from '@/application/shared/functions.js'
import courseprogress from "../progress/index.vue";

export default {
    name: 'course',
    props: {
        id : String
    },
    components : {
        courseprogress
    },
    data : function(){

        return {
            loading : false,
            error : null,
            course : null,
            f
        }

    },

    created : () => {

    },

    watch: {
        id : {
            immediate : true,
            handler : function(){
                this.destroy()
                this.create()
                this.load()
            }
        },
    },
    computed: mapState({
        auth : state => state.auth,
        ageCluster : function(){
            if(!this.course) return null

            return f.findCluster(this.course.age, f.deep(this.core, 'appInfo.snippity.settings.ageClusters') || [])
        },

        admin : function(){
            return this.core.user.checkFeatures(['admin'])
        },

        haslicense : function(){
            return this.core.user.checkFeatures(['lessons'])
        },

        progress : function(state){

            if(!this.course) return null

            return state._progress[this.course.uid]
        },

        lessonStatuses : function(){

            if(!this.progress || !this.course) return null

            var ls = this.progress.lessonStatuses(this.course, 'lesson')
            
            return ls
        }
    }),

    methods : {
        destroy : function(){},
        create : function(){},
        share : function(){
            
            this.core.vueapi.share({
                url : 'https://' + this.core.domain + '/courses/' + this.id
            })
        },

        courseProgressLabel : function(status){

            if(!status){
                return 'snippity.course.restrictionUndefined'
            }

            if(status.value == 'finished') return 'snippity.course.finishedstatus'
            if(status.value == 'current'){

                if(!status.waituntil){
                    return 'snippity.course.currentstatus'
                }
                else{
                    return 'snippity.course.restrictionUntil'
                } 
            }

            return 'snippity.course.restrictionstatus'
        },

        load : function(){

            if(!this.id){
                this.error = '404'

                return
            }

            this.loading = true
            this.resloading = true
            
            var promise = this.core.api.lessons.get(this.id)

            promise.then((course) => {
                this.course = course

                if (this.auth){
                    this.core.api.lessons.progress.get([this.id]).then(r => {
                    })
                }
                

            }).catch(e => {
                this.error = e
            }).finally(() => {
                this.loading = false
            })
        },

        openStory : function(id){
            this.core.vueapi.story({
                autoplay : true,
                id
            }, {
                close : () => {
                    /*if (playing){
                        this.play()
                    }*/
                }
            })
        },

        createalllessons : function(i){

            if(!this.admin) return

            this.$dialog.confirm(
				this.$t('snippity.course.createalllessonsquestion'), {
				okText: this.$t('yes'),
				cancelText : this.$t('no')
			})
	
			.then((dialog) => {

				this.core.promwrapper(this.core.api.lessons.admin.createlesson(this.course.uid), { hideicons : true } ).then(() => {

                    this.$dialog.alert(
                        this.$t('snippity.course.createalllessonsSuccess'), {
                        okText: this.$t('app.okay')
                    }).catch(e => {

                    })

                }).catch(e => {
                    console.log("E", e)
                
                    this.$dialog.alert(
                        JSON.stringify(e), {
                        okText: this.$t('app.okay')
                    }).catch(e => {

                    })
                })

			}).catch( e => {
				
			})

           
        },

        recreateLesson : function(i){

            if(!this.admin) return

            this.$dialog.confirm(
				this.$t('snippity.course.recreatelessonquestion'), {
				okText: this.$t('yes'),
				cancelText : this.$t('no')
			})
	
			.then((dialog) => {

				this.createLesson(i, f.makeid())

			}).catch( e => {
				
			})

           
        },

        joincourse : function(){
            this.core.promwrapper(this.core.api.lessons.join.set(this.course.uid) ).then(() => {
                this.$router.push('/joined/' + this.course.uid).catch(e => {})
            }).catch(e => {

                console.log("E", e)

                if(e.error == 'limit'){
                    this.$dialog.alert(
                        this.$t('snippity.course.joinLimit'), {
                        okText: this.$t('app.okay')
                    }).catch(e => {

                    })   
                }
            })
        },

        createLesson : function(i, key){

            if(!this.admin) return

            this.core.promwrapper(this.core.api.lessons.admin.createlesson(this.course.uid, i, key), { hideicons : true } ).then(() => {

                this.$dialog.alert(
                    this.$t('snippity.course.createlessonSuccess'), {
                    okText: this.$t('app.okay')
                }).catch(e => {

                })

            }).catch(e => {

                this.$dialog.alert(
                    JSON.stringify(e), {
                    okText: this.$t('app.okay')
                }).catch(e => {

                })
            })
        },

        removereturn : function(bit){

            this.$dialog.confirm(
				this.$t(!bit ? 'snippity.course.returncourseq' : 'snippity.course.removecourseq'), {
				okText: this.$t('yes'),
				cancelText : this.$t('no')
			})
	
			.then((dialog) => {

				this.core.api.lessons.admin.removereturn(this.course.uid, bit).then(r => {
                    this.load()

                    this.$store.commit('icon', {
                        icon: 'success'
                    })

                })

			}).catch( e => {
				
			})

            
        },

        cancelcourse : function(){
            this.$dialog.confirm(
				this.$t('snippity.course.cancelcourseqestion'), {
				okText: this.$t('yes'),
				cancelText : this.$t('no')
			})
	
			.then((dialog) => {

                this.core.promwrapper( this.core.api.lessons.join.cancel(this.course.uid) ).then(() => {
                    this.load()
                }).catch(e => {

                })

			}).catch( e => {
				
			})
        }
    },
}